import type * as lazyComposeIndex from "./lazyComposeIndex";
import { LazyAction, LazyModule } from "owa-bundling";

export const lazyModule: LazyModule<typeof lazyComposeIndex> = new LazyModule(() => import(/* webpackChunkName: "ComposeRibbonTabs" */ "./lazyComposeIndex"), { name: "ComposeRibbonTabs" });

export const lazyGetSLRComposeTabs: LazyAction<typeof lazyComposeIndex.getSLRComposeTabs, typeof lazyModule> = new LazyAction(lazyModule, m => m.getSLRComposeTabs);
export const lazyGetMLRComposeTabs: LazyAction<typeof lazyComposeIndex.getMLRComposeTabs, typeof lazyModule> = new LazyAction(lazyModule, m => m.getMLRComposeTabs);
